import React from 'react';
import {twMerge} from "tailwind-merge";

export default function Ribbon({label, className }) {
    if (!label) return null;

    return (
        <p className={twMerge('text-[0.875rem] font-normal leading-[1.43] m-0 absolute right-0 bottom-6 bg-mint-green text-white -rotate-[30deg] translate-x-[48px] py-[2px] px-[48px]', className)}>
            <b>{label}</b>
        </p>
    );
}
